// extracted by mini-css-extract-plugin
module.exports = {"BotaoMenu":"BotaoMenu_BotaoMenu__2io-8","ativo":"BotaoMenu_ativo__2xqlo"};